import React from "react";

export default function option({ name, value }) {
  return (
    <>
      <option key={value} value={value} selected={name === "India"} style={{ color: localStorage.getItem('theme') === 'dark' ? 'lightgray' : "#212529", backgroundColor: localStorage.getItem('theme') === 'dark' ? '#212529' : "lightgray" }} >{name}</option>
    </>
  );
}
